import { GA_PROMOTION_ATTRIBUTE } from '@common/Tracking';

const DEFAULT_SELECTOR = `[${GA_PROMOTION_ATTRIBUTE}]`;

export const findPromotionBanners = (parentNode, selector = DEFAULT_SELECTOR) => {
    const promotionElements = (parentNode || document).querySelectorAll(selector);
    const promotionArray = [];

    if (promotionElements) {
        promotionElements.forEach((elm) => {
            if (elm.offsetParent !== null) {
                promotionArray.push(elm);
            }
        });
    }

    return promotionArray;
};
